import { useLocation } from 'react-router-dom'
import { PageHero } from '../components/page-hero/PageHero'
import { useRouteMetadata } from '../components/inventory/useRouteMetadata'
import { useI18n } from '../i18n/I18nProvider'
import { InquiryForm } from './ContactPage'

export function SellVehiclePage() {
  const { language, t } = useI18n()
  const { pathname } = useLocation()
  useRouteMetadata({ title: `${t('sell.formTitle')} — TS Auto`, description: t('sell.intro'), pathname, language })
  return <div className="sell-page">
    <PageHero variant="request" eyebrow={t('hero.sellEyebrow')} title={t('sell.title')}><p>{t('sell.intro')}</p></PageHero>
    <section className="contact-form-section" aria-labelledby="sell-form-title">
      <div className="page-frame contact-layout">
        <aside className="sell-intro">
          <h2 id="sell-form-title">{t('sell.formTitle')}</h2>
          <p>{t('sell.formIntro')}</p>
          <h3>{t('sell.nextTitle')}</h3>
          <p>{t('sell.nextBody')}</p>
        </aside>
        <div className="contact-form-panel"><InquiryForm valuation /></div>
      </div>
    </section>
  </div>
}
